import { Controller } from "@hotwired/stimulus";

/**
 * Carousel Indicators Controller
 *
 * Updates indicator dots based on the currently visible carousel item.
 * Uses Intersection Observer to detect which item is in view.
 *
 * @extends Controller
 * @property {HTMLElement} carouselTarget - The carousel container
 * @property {HTMLElement[]} indicatorTargets - The indicator dot links
 */
export default class extends Controller {
  static targets = ["carousel", "indicator"];

  connect() {
    this.setupIntersectionObserver();
  }

  /**
   * Set up Intersection Observer to track visible carousel items
   */
  setupIntersectionObserver() {
    const options = {
      root: this.carouselTarget,
      rootMargin: "0px",
      threshold: 0.5, // Item must be 50% visible
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = parseInt(entry.target.id.split("-")[1]);
          this.updateIndicators(index);
        }
      });
    }, options);

    // Observe all carousel items
    const items = this.carouselTarget.querySelectorAll(".carousel-item");
    items.forEach((item) => this.observer.observe(item));
  }

  /**
   * Update indicator styling based on current index
   */
  updateIndicators(currentIndex) {
    this.indicatorTargets.forEach((indicator, index) => {
      if (index === currentIndex) {
        indicator.classList.add("bg-black");
        indicator.classList.remove("bg-oakwyn-gray-light");
      } else {
        indicator.classList.add("bg-oakwyn-gray-light");
        indicator.classList.remove("bg-black");
      }
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}